import { ApiResource } from '@/core/models/ApiResource.interface';
import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { WorkMaterialType } from './work-material-type.interface';
import { WorkMaterialTypeService } from './work-material-type.service';

const service = new WorkMaterialTypeService();

export interface WorkMaterialTypeState {
   workMaterialTypesOverview?: ApiResource<Array<WorkMaterialType>>;
}

const WorkMaterialTypeStore: Module<WorkMaterialTypeState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {
      SET_WORK_MATERIAL_TYPE_OVERVIEW(state, workMaterialTypesOverview: ApiResource<Array<WorkMaterialType>>) {
         state.workMaterialTypesOverview = workMaterialTypesOverview;
      },
      ADD_WORK_MATERIAL_TYPE(state, workMaterialType: WorkMaterialType) {
         state.workMaterialTypesOverview?.data.push(workMaterialType);
      },
      SET_WORK_MATERIAL_TYPE(state, workMaterialType: WorkMaterialType) {
         const index = (state.workMaterialTypesOverview?.data || []).findIndex((wmt) => wmt.id === workMaterialType.id);
         if (index > -1) state.workMaterialTypesOverview?.data.splice(index, 1, workMaterialType);
      },
      DELETE_WORK_MATERIAL_TYPE(state, workMaterialTypeId: number) {
         const index = (state.workMaterialTypesOverview?.data || []).findIndex((wmt) => wmt.id === workMaterialTypeId);
         if (index > -1) state.workMaterialTypesOverview?.data.splice(index, 1);
      },
   },
   actions: {
      async getWorkMaterialTypes(context, payload: { employerId: number; query?: LocationQuery }) {
         const workMaterialTypesOverview = await service.getWorkMaterialTypes(payload.employerId, payload.query);
         context.commit('SET_WORK_MATERIAL_TYPE_OVERVIEW', workMaterialTypesOverview);
         return workMaterialTypesOverview;
      },
      async getWorkMaterialType(context, payload: { employerId: number; workMaterialTypeId: number; query?: LocationQuery }) {
         const response = await service.getWorkMaterialType(payload.employerId, payload.workMaterialTypeId, payload.query);
         return response.data;
      },
      async createWorkMaterialType(context, payload: { employerId: number; workMaterialType: WorkMaterialType }) {
         const response = await service.postWorkMaterialType(payload.employerId, payload.workMaterialType);
         context.commit('ADD_WORK_MATERIAL_TYPE', response.data);
         return response.data;
      },
      async changeWorkMaterialType(
         context,
         payload: { employerId: number; workMaterialTypeId: number; workMaterialType: WorkMaterialType },
      ) {
         const response = await service.putWorkMaterialType(payload.employerId, payload.workMaterialTypeId, payload.workMaterialType);
         context.commit('SET_WORK_MATERIAL_TYPE', response.data);
         return response.data;
      },
      async deleteWorkMaterialType(context, payload: { employerId: number; workMaterialTypeId: number }) {
         await service.deleteWorkMaterialType(payload.employerId, payload.workMaterialTypeId);
         context.commit('DELETE_WORK_MATERIAL_TYPE', payload.workMaterialTypeId);
      },
   },
};

export default WorkMaterialTypeStore;
